import {ProductRealImages} from 'components/DetailGoodPage/ProductRealImages';
import React, {FC, useState} from 'react';

import { ProductAttributes, ProductDescription, ProductDocuments } from 'app/products';
import { IGood } from 'entities/products';
import { ProductInfoAccordion } from '../ProductInfoAccordion';
import { Icon } from '@nebo-team-dev/vobaza.ui.icon';

import styles from './styles.module.scss';

interface Description {
  product: IGood;
}

const ProductDescriptions: FC<Description> = ({ product }) => {
  const [collapseDesc, setCollapseDesc] = useState(false);
  const description = collapseDesc ? product?.description_full : product?.description_full?.slice(0, 400);

  return (
        <div>
            <div>
                {(product.description_full || product.documents) && (
                    <div className={styles.productAccordionBlock}>
                    <ProductInfoAccordion title="Описание" autoDuration>
              {description && <ProductDescription html={description} />}
              {product?.description_full?.length > 400 && (
                <button onClick={() => setCollapseDesc(!collapseDesc)} className={styles.showMoreButton}>
                  {!collapseDesc ? 'Показать полностью' : 'Скрыть описание'}
                  {!collapseDesc ? <Icon name="SmallArrowDown" /> : <Icon name="SmallArrowUp" />}
                </button>
              )}
              {product.documents && <ProductDocuments documents={product.documents} />}
            </ProductInfoAccordion>
          </div>
        )}
      </div>

      <div>
        {Boolean(product.attributes?.length || product.product_weight || product.assembly) && (
          <div className={styles.productAccordionBlock}>
            <ProductInfoAccordion title="Характеристики и размеры" autoDuration>
              <ProductAttributes
                attributes={product.attributes}
                weight={product.product_weight || null}
                assembly={product.assembly}
              />
            </ProductInfoAccordion>
            {Boolean(product.real_images?.length) && <ProductRealImages images={product.real_images} />}
          </div>
        )}
      </div>
    </div>
  );
};

export { ProductDescriptions };
